export const orderStatuses = [
  'complete',
  'en_route',
  'booked',
  'booking',
  'canceled',
  'arrived',
  'created',
];
